import { GetInfoBannerArgs } from 'types/api/arguments/get-info-banner-args'
import { InfoBannerResp } from 'types/api/response/info-banner-resp'

import { api } from './api'

export const getInfoBanner = ({ screen, params }: GetInfoBannerArgs) =>
  api.get<InfoBannerResp>(`/info_banners/${screen}`, { params })
